import { Clock, GlassWater, Music, Users, Heart, Camera } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { CtaBanner } from "@/components/CtaBanner";
import { Reveal, Overline } from "@/components/motion";
import { IMAGES } from "@/data/site";

const DETAILS = [
  { icon: Clock, title: "3 ore", text: "Plecăm cu două ore înainte de apus și revenim sub primele stele." },
  { icon: GlassWater, title: "Șampanie & platouri", text: "Un pahar de bun venit și platouri reci incluse. Vinul apusului, la propriu." },
  { icon: Music, title: "Muzică ambientală", text: "Playlistul vostru sau selecția noastră — mereu la volum de conversație." },
  { icon: Users, title: "Până la 10 invitați", text: "Intim prin definiție. Doar voi, marea și lumina aceea de aur." },
  { icon: Heart, title: "Ocazii speciale", text: "Cereri în căsătorie, aniversări, logodne — știm să păstrăm un secret." },
  { icon: Camera, title: "Golden hour", text: "Cea mai bună lumină a zilei, garantată de astronomie, nu de noi." },
];

const Apus = () => (
  <div data-testid="apus-page">
    <PageHero
      testid="apus-hero"
      image={IMAGES.sunset}
      alt="Velier decupat în lumina portocalie a apusului de soare"
      overline="Croazieră de Seară · 3 Ore"
      titleLines={["Apus de soare.", "Pahare sus."]}
      subtitle="Cea mai simplă și mai frumoasă experiență a noastră: pleci din port pe lumină caldă, vezi soarele intrând în mare și revii sub stele."
    />

    <section className="mx-auto max-w-[1440px] px-6 py-24 lg:px-12 lg:py-32">
      <Reveal className="mx-auto max-w-3xl text-center">
        <Overline className="mb-8">Momentul</Overline>
        <p className="font-serif text-2xl font-light leading-relaxed text-ivory sm:text-3xl">
          „Există un minut, chiar înainte ca soarele să atingă linia mării,
          în care toată lumea de la bord tace de la sine.
          <span className="italic text-gold"> Acela este motivul pentru care facem asta.”</span>
        </p>
        <p className="mt-8 text-xs uppercase tracking-[0.3em] text-mist">
          — Skipperul vostru
        </p>
      </Reveal>
    </section>

    <section className="border-y border-white/10 bg-deep">
      <div className="mx-auto max-w-[1440px] px-6 py-24 lg:px-12 lg:py-32">
        <Reveal className="mb-16">
          <Overline className="mb-6">Detalii</Overline>
          <h2 className="font-serif text-3xl font-light text-ivory sm:text-4xl">
            Puțin program, <span className="italic text-gold">multă atmosferă.</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {DETAILS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.06} className="bg-deep">
              <div className="h-full p-8">
                <item.icon className="h-5 w-5 text-gold" />
                <h3 className="mt-5 font-serif text-lg text-ivory">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mist">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-16 flex flex-col items-start justify-between gap-6 border border-gold/30 p-8 sm:flex-row sm:items-center lg:p-10">
            <div>
              <p className="text-[10px] uppercase tracking-[0.3em] text-gold">Tarif orientativ</p>
              <p className="mt-3 font-serif text-3xl font-light text-ivory">
                De la 100 € <span className="text-lg text-mist">/ croazieră (grup privat)</span>
              </p>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-mist">
              Croaziere în fiecare seară de sezon, dacă vremea ține cu noi.
              Ora plecării se stabilește în funcție de apus.
            </p>
          </div>
        </Reveal>
      </div>
    </section>

    <CtaBanner
      title="Soarele apune în fiecare zi. Tu când vii?"
      subtitle="Rezervă seara ta pentru sezonul 2027 — datele din jurul apusului perfect sunt cele mai căutate."
    />
  </div>
);

export default Apus;
